var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-green-500  font-semibold flex items-center p-3 rounded-lg fixed  ",class:_vm.position},[_c('span',[_c('Icontoasche')],1),_c('span',{staticClass:"ml-2 text-white"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }